import styled from "@emotion/styled";
import {Container } from "@mui/material";

export const StyledContainer = styled(Container)({
  backgroundColor: '#F5F5F5',
  height: "100%",
  maxWidth: "100%"
});